import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AutoconsumoRoutingModule} from "./autoconsumo-routing.module";
import {AgGridModule} from "ag-grid-angular";
import {
  LfsaBotonEditarGridComponent
} from "../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {LfsaBotonsGridComponent} from "../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component";
import {CheckboxRenderer} from "../../shared/components/lfsa-checkbox/lfsa-checkbox.component";
import {CreacionMantenedorComponent} from './views/creacion-mantenedor/creacion-mantenedor.component';
import {MotivoPedidoComponent} from './views/motivo-pedido/motivo-pedido.component';
import {SharedModule as VdiShared} from "../vdi/shared/shared.module";
import {SharedModule} from "../../shared/shared.module";
import {
  MantenedorSolicitudPedidoVentaComponent
} from './views/mantenedor-solicitud-pedido-venta/mantenedor-solicitud-pedido-venta.component';
import {
  SolicitudPedidoVentaAutoconsumoComponent
} from './views/mantenedor-solicitud-pedido-venta/components/solicitud-pedido-venta-autoconsumo/solicitud-pedido-venta-autoconsumo.component';
import {
  LineaDetalleComponent
} from './views/mantenedor-solicitud-pedido-venta/components/linea-detalle/linea-detalle.component';
import {
  ImputacionComponent
} from './views/mantenedor-solicitud-pedido-venta/components/imputacion/imputacion.component';
import {
  ModalCuentaContableComponent
} from './views/motivo-pedido/components/modal-cuenta-contable/modal-cuenta-contable.component';
import {
  GestorSolicitudPedidoVentaComponent
} from "./views/gestor-solicitud-pedido-venta/gestor-solicitud-pedido-venta.component";
import {
  SelectorPedidoVentaAutoconsumoComponent
} from "./views/gestor-solicitud-pedido-venta/components/selector-pedido-venta-autoconsumo/selector-pedido-venta-autoconsumo.component";
import {
  SelectorLineaDetalleComponent
} from "./views/gestor-solicitud-pedido-venta/components/selector-linea-detalle/selector-linea-detalle.component";
import {
  SelectorImputacionComponent
} from "./views/gestor-solicitud-pedido-venta/components/selector-imputacion/selector-imputacion.component";
import {TooltipModule} from "ng2-tooltip-directive";
import {NgSelectModule} from "@ng-select/ng-select";


@NgModule({
  declarations: [
    CreacionMantenedorComponent,
    MotivoPedidoComponent,
    MantenedorSolicitudPedidoVentaComponent,
    SolicitudPedidoVentaAutoconsumoComponent,
    LineaDetalleComponent,
    GestorSolicitudPedidoVentaComponent,
    SelectorPedidoVentaAutoconsumoComponent,
    SelectorLineaDetalleComponent,
    SelectorImputacionComponent,
    ImputacionComponent,
    ModalCuentaContableComponent,
  ],
  imports: [
    CommonModule,
    AutoconsumoRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent, CheckboxRenderer]),
    FormsModule,
    VdiShared,
    TooltipModule,
    NgSelectModule
  ],
  providers: []
})
export class AutoconsumoModule {
}
